/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ModelPriceRow,
  ModelPriceRow$inboundSchema,
  ModelPriceRow$Outbound,
  ModelPriceRow$outboundSchema,
} from "./modelpricerow.js";

export type ListModelPricesResponse = {
  object: "list";
  data: Array<ModelPriceRow>;
};

/** @internal */
export const ListModelPricesResponse$inboundSchema: z.ZodType<
  ListModelPricesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(ModelPriceRow$inboundSchema),
});
/** @internal */
export type ListModelPricesResponse$Outbound = {
  object: "list";
  data: Array<ModelPriceRow$Outbound>;
};

/** @internal */
export const ListModelPricesResponse$outboundSchema: z.ZodType<
  ListModelPricesResponse$Outbound,
  z.ZodTypeDef,
  ListModelPricesResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(ModelPriceRow$outboundSchema),
});

export function listModelPricesResponseToJSON(
  listModelPricesResponse: ListModelPricesResponse,
): string {
  return JSON.stringify(
    ListModelPricesResponse$outboundSchema.parse(listModelPricesResponse),
  );
}
export function listModelPricesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListModelPricesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListModelPricesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListModelPricesResponse' from JSON`,
  );
}
